export default __webpack_public_path__ + "static/media/A9.3a90a553.jpg";